import React from 'react';
import PropTypes from "prop-types";

import './Input.scss';

export default function Input(props) {
  const { value = '', setValue = () => {}, placeholder = 'Please type here..', hasError = false, showIcon = true,
    Icon = null, errorMessage = 'Please enter valid value *', className, size = 18, disabled = false
  } = props;

  const onChangeValue = (e) => {
    if (disabled) return;
    const val = e.target.value;
    setValue(val);
  };

  return (
    <div className={`pos_relative inputWrapper ${disabled ? "disabledInputWrapper" : ""}`}>
      {Icon ? <Icon size={size} /> : null}

      <input
        value={value}
        placeholder={placeholder}
        onChange={onChangeValue}
        className={`inputField ${hasError ? "inputErrorBox" : ''} ${showIcon ? 'withIcon' : ''} ${className}`}
        disabled={disabled}
      />

      {hasError && <div className='error'>{errorMessage}</div>}
    </div>
  );
};

Input.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func,
  placeholder: PropTypes.string,
  hasError: PropTypes.bool,
  Icon: PropTypes.elementType,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  disabled: PropTypes.bool,
};